import gsap from "gsap";

const VideoModule = (() => {

    const SELECTOR_MODULE = '.video__module';
    const SELECTOR_CONTROLS = '.video__controls';
    const SELECTOR_CONTROL_BTN = '.btn-video--control';
    const CLASS_PLAY_BTN = "btn-video--play";
    const CLASS_PAUSE_BTN = 'btn-video--pause';
    const SELECTOR_POSTER = ".fake-poster";
    const SELECTOR_LOADER = ".loader";


    const videoInstances = new WeakMap();


    const initialize = module => {

        if (module?.classList.contains('video__module')) {
            return initVideo(module);
        }
    };

    const initVideo = (module) => {


        if (videoInstances.has(module)) {
            return videoInstances.get(module);
        }

        const controlsEl = module.querySelector(SELECTOR_CONTROLS);
        const controlBtn = controlsEl.querySelector(SELECTOR_CONTROL_BTN);
        const videoEl = module.querySelector("video");
        const posterEl = module.querySelector(SELECTOR_POSTER);
        const loaderEl = module.querySelector(SELECTOR_LOADER);

        /**
         * event handler for playing/pausing video on user interaction
         * @param {*} e 
         */
        const handlePlayVideo = (e) => {

            e.preventDefault();
            e.stopPropagation();

            if (videoEl.paused) {
                videoEl.play();
            } else {
                videoEl.pause();
            }
        }

        const handleResetVideo = video => {
            video.pause();
            video.currentTime = 0;
            /* video.load(); */ // this reloads the video so dont use!!
            video.dispatchEvent(new Event('pause'));
        }

        const revealPoster = () => {
            gsap.to(posterEl,
                {
                    autoAlpha: 1,
                    duration: .5,
                    ease: 'ease.in'
                })
        }

        const loadVideo = () => {

            console.debug('start loading video');

            return new Promise((resolve, reject) => {
                // if already loaded
                if (videoEl.readyState >= 3) {
                    console.debug('video: loaded');
                    resolve(videoEl);
                    return;
                }

                loaderEl.classList.add('show');

                const onReady = () => {
                    console.debug('video: ready/canplay');
                    cleanup();
                    resolve(videoEl);
                };

                const onError = () => {
                    cleanup();
                    reject(new Error('Video failed to load'));
                };

                function cleanup() {
                    videoEl.removeEventListener('canplay', onReady);
                    videoEl.removeEventListener('error', onError);
                    loaderEl.classList.remove('show');
                }

                videoEl.addEventListener('canplay', onReady, { once: true });
                videoEl.addEventListener('error', onError, { once: true });

                videoEl.load();
            });
        };

        const playVideo = () => videoEl.play()
            .then(() => {
                console.debug("Video started playing");
            })
            .catch(err => {
                console.error("Video playback failed:", err.name, err.message);
            });


        const showPause = e => {
            controlBtn.classList.remove(CLASS_PLAY_BTN);
            controlBtn.classList.add(CLASS_PAUSE_BTN);
        }

        const showPlay = e => {
            controlBtn.classList.remove(CLASS_PAUSE_BTN);
            controlBtn.classList.add(CLASS_PLAY_BTN);
        }


        controlBtn.addEventListener('click', handlePlayVideo);
        videoEl.addEventListener("playing", showPause);
        videoEl.addEventListener("pause", showPlay);
        videoEl.addEventListener("ended", () => handleResetVideo(videoEl));
        videoEl.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        const instance = {
            controls: controlsEl,
            video: videoEl,
            poster: posterEl,
            revealPoster,
            load: () => loadVideo(),
            play: () => playVideo(),
            reset: () => handleResetVideo(videoEl)
        };

        videoInstances.set(module, instance);

        return instance;
    };

    const getInstanceByModule = module => videoInstances.get(module);

    return {
        SELECTOR_MODULE,
        initialize,
        getInstance: getInstanceByModule
    }

})();


export default VideoModule;